import styled from 'styled-components'

export const LastRowWrapper = styled.div`
    display: flex;
`
